var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85797 5.83333L6.38214 7.3575C6.70752 7.68289 6.70752 8.21045 6.38213 8.53583C6.05675 8.86122 5.52919 8.86122 5.2038 8.53583L1.66797 5L5.2038 1.46417C5.52919 1.13878 6.05675 1.13878 6.38214 1.46417C6.70752 1.78955 6.70752 2.31711 6.38213 2.6425L4.85797 4.16667H10.8346C12.6027 4.16667 14.2984 4.86905 15.5487 6.11929C16.7989 7.36953 17.5013 9.06522 17.5013 10.8333C17.5013 12.6014 16.7989 14.2971 15.5487 15.5474C14.2984 16.7976 12.6027 17.5 10.8346 17.5H4.16797C3.70773 17.5 3.33464 17.1269 3.33464 16.6667C3.33464 16.2064 3.70773 15.8333 4.16797 15.8333H10.8346C12.1607 15.8333 13.4325 15.3066 14.3702 14.3689C15.3079 13.4312 15.8346 12.1594 15.8346 10.8333C15.8346 9.50725 15.3079 8.23548 14.3702 7.2978C13.4325 6.36012 12.1607 5.83333 10.8346 5.83333H4.85797Z",
    fill: "#2C304B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.9b5762136a74e722c785f6595580eff7.svg";
export { ForwardRef as ReactComponent };